
import {
  API_URL, getApi,
} from "@/service/api";

import router from "../../router";
import moment from "moment";


const routes = {
  api_documents: "/api/me"
}

const sortByDate = (a, b) => {
  if (moment(a.date, "DD-MM-YYYY").isBefore(moment(b.date, "DD-MM-YYYY"))) {
    return 1;
  } else if (
    moment(a.date, "DD-MM-YYYY").isAfter(moment(b.date, "DD-MM-YYYY"))
  ) {
    return -1;
  } else {
    return 0;
  }
};

const state = {
  documents: [],
}

const mutations = {
  setDocuments(state, payload) {
    state.documents = payload;
  },
}

const actions = {
  listDocuments({ commit }, po_box = null) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      if (!po_box) { 
        commit("setDocuments", []);
        commit("auth/LOGIN_SUCCESS", null, { root: true });
        return  
      }
      const uri = API_URL + routes.api_documents + `/${po_box}`;
      const response = getApi(uri);
      response.then((res) => {
        console.log("res", res)
        commit("setDocuments", res.data.documents);
        commit("auth/LOGIN_SUCCESS", null, { root: true });
      })
      response.catch(() => {
        localStorage.removeItem("token");
        commit("auth/LOGIN_ERROR", null, { root: true });
        router.push('/login');
      });
    }
  },
  resetDocuments({commit}) {
    commit("auth/LOGIN_REQUEST", null, { root: true });
    commit("setDocuments", []);
    commit("auth/LOGIN_SUCCESS", null, { root: true });
  }
}

const getters = {
  listGuiasMadre(state) {
    return state.documents?.guiasMadre !== undefined ? state.documents.guiasMadre.sort(sortByDate) : false
  },
  listGuias(state) {
    return state.documents?.guias !== undefined ? state.documents.guias.sort(sortByDate) : false
  },
  listFacturas(state) {
    return state.documents?.facturas !== undefined ? state.documents.facturas.sort(sortByDate) : false
  },
  listRecibos(state) {
    return state.documents?.recibos !== undefined ? state.documents.recibos.sort(sortByDate) : false
  },
  listParticulares(state) {
    return state.documents?.particulares !== undefined ? state.documents.particulares.sort(sortByDate) : false
  },
  listCaratulas(state) {
    return state.documents?.caratulas !== undefined ? state.documents.caratulas.sort(sortByDate) : false
  },
  listNotasCredito(state) {
    return state.documents?.notasCredito !== undefined ? state.documents.notasCredito.sort(sortByDate) : false
  },
  listOtros(state) {
    return state.documents?.otros !== undefined ? state.documents.otros.sort(sortByDate) : false
  },
}


// exportar propiedades
export const documents = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
